import {ref} from "vue";
export const CurrencyType = ref([
    {code: 'GBP', name: 'British Pound', symbol: '£', id: 0 },
    {code: 'USD', name: 'US Dollar', symbol: '$', id: 1 },
    {code: 'EUR', name: 'Euro', symbol: '€', id: 2 },
])